import { createAction, createReducer } from 'redux-act';

const DEFAULT_STATE_CBR = { selectedItems: { technologies: {}, ranges: {}, references: {} } };

const setCBRSelectedItemsAction = createAction('SET_CBR_SELECTED_ITEMS');
const resetCBRSelectedItemsAction = createAction('RESET_CBR_SELECTED_ITEMS');

export const callByRangeReducer = createReducer(function (on, off) {
  on(setCBRSelectedItemsAction, (state, payload) => {
    return {
      ...payload
    };
  });
  on(resetCBRSelectedItemsAction, (state, payload) => {
    return {
      ...DEFAULT_STATE_CBR
    };
  });
}, DEFAULT_STATE_CBR);

export const setCBRSelectedItems = (items) => {
  return dispatch => {
    dispatch(setCBRSelectedItemsAction(items));
  }
}

export const resetCBRSelectedItems = () => {
  return dispatch => {
    dispatch(resetCBRSelectedItemsAction());
  }
}
